export const AUTH_API_ENDPOINTS = {
  CHANGE_CONTACT_INIT: '/auth/change-contact/init',
  CHANGE_CONTACT_RESEND: '/auth/change-contact/resend',
  CHANGE_CONTACT_VERIFY: '/auth/change-contact/verify',
  COMPLETE_SIGN_UP_PATH: '/auth/sign-up/verify',
  CONFIRM_RESET_PASSWORD_PATH: '/auth/confirm-reset-password',
  DASHBOARD_PERMISSION_PATH: '/auth/dashboard-permission',
  GET_BIOMETRIC_TOKEN: '/auth/get-biometric-token',
  PHONE_SIGN_IN_INIT: '/auth/sign-in/init',
  PHONE_SIGN_IN_VERIFY: '/auth/sign-in/verify',
  RE_SEND_EMAIL_CODE_PATH: '/auth/re-send-email-code',
  RE_SEND_PHONE_CODE_PATH: '/auth/resend-code',
  RE_SEND_RESET_PASSWORD_CODE_PATH: '/auth/reset-password/resend-code',
  RESET_PASSWORD_COMPARE_CODE: '/auth/reset-password/verify',
  RESET_PASSWORD_INSTRUCTION_PATH: '/auth/reset-password/init',
  RESET_PASSWORD_PATH: '/auth/reset-password',
  SIGN_IM_PATH: '/auth/sign-in',
  SIGN_IN_VIA_BIOMETRIC_TOKEN: '/auth/sign-in-via-biometric-token',
  SIGN_UP_PATH: '/auth/sign-up',
  SIGN_UP_RESEND_CODE: '/auth/sign-up/resend-code',
  UPDATE_BIOMETRIC_STATUS: '/auth/update-user-biometric-status',
};
